import { Content } from './Content'
import { Device, WindowSize } from '../helpers'
import WebModel from '../models/WebModel'
import { ExperimentFlag } from '../enums/ExperimentFlag'
import { Slot } from './Slot'
import { TABLET_WIDTH } from '../constants'
import { IBidRequest, IPrebidAdUnit } from '../../typings/IPrebid'
import { deepcopy } from '../helpers/deepcopy'

interface IContentSlotModel extends ISlotModel {
  selector: HTMLElement
}
const BELOW_OFFSET_MULTIPLIER = 0.5

export class BelowContent extends Slot {
  slotName = 'other'
  adUnitId = Device.isMobileOrTablet ? `content_mobile` : `content_btf` // `below_content`
  selector: HTMLElement
  lazy = true
  offset = WindowSize.height * BELOW_OFFSET_MULTIPLIER
  dynamic = false

  constructor(slotModel: IContentSlotModel, model: WebModel) {
    super(slotModel, model)

    // Don't display this slot if zergnet is active
    if (model.zergnet) {
      return
    }

    this.timeout = 500
    this.insertPosition = 'afterend'

    const selectorQuery = Device.isMobileOrTablet
      ? model.content_selector_mobile
      : model.content_selector
    const selectorEl = selectorQuery
      ? (document.querySelector(selectorQuery) as HTMLElement)
      : null

    if (selectorEl) {
      this.selector = selectorEl
      this.target = selectorEl
      this._sizes = Device.isMobileOrTablet
        ? this.getMobileSizes(this.model)
        : this.getDesktopSizes(this.model)
    }
  }

  get id(): string {
    return 'below_content'
  }

  get bidRequests(): Array<IBidRequest> {
    // We want to use content's bidRequest models
    const spoofAdunit = Device.isMobileOrTablet
      ? 'content_mobile'
      : 'content_btf'
    const unit = this.model.bidRequests[spoofAdunit]
    return deepcopy(unit)
  }

  template(): string {
    const template = `
      <div id="${this.wrapperId}" class="adunitwrapper below_content_wrapper" data-wrapper='${this.id}'>
        <div id="${this.id}" class="below_content adunit">
        </div>
      </div>
    `

    if (Device.isMobileOrTablet) {
      return `<div class='remove_padding'> ${template} </div>`
    }
    return template
  }

  protected getDesktopSizes(model: WebModel): AdSizes {
    const element = this.selector
    const parent = element && (element.parentNode as HTMLElement | null)
    const width = (parent && parent.offsetWidth) || 300
    const sizes: AdSizes = [[300, 250]]
    if (width >= TABLET_WIDTH) {
      sizes.push([728, 90])
    }
    if (width >= 336) {
      sizes.push([336, 280], [468, 60], [250, 250])
    }
    if (!model.disableContentBtfNative) {
      sizes.push('fluid')
    }

    return sizes
  }

  protected getMobileSizes(model: WebModel): AdSizes {
    const sizes: AdSizes = [
      [300, 250],
      [320, 50],
      [300, 50],
      [320, 100],
      [336, 280],
      [468, 60],
      [728, 90],
      'fluid'
    ]

    return sizes
  }
}
